import {
  LoadingButton as MuiButton,
  LoadingButtonProps as MuiButtonProps,
} from "@mui/lab";
import { styled } from "@mui/material";
import { CSSProperties } from "@mui/material/styles/createMixins";

export interface ButtonProps extends MuiButtonProps {
  rounded?: "full" | "none";
}

const extraProps: PropertyKey[] = ["rounded"];

export const Button = styled(MuiButton, {
  shouldForwardProp: (prop) => !extraProps.includes(prop),
})<ButtonProps>(({ rounded }) => {
  const styles: CSSProperties = {};

  if (rounded === "full") {
    Object.assign(styles, {
      borderRadius: "9999px",
    });
  }
  return styles;
}) as typeof Button;

Button.defaultProps = {
  variant: "contained",
  rounded: "none",
};
